import React, { useMemo, memo } from "react";
import { theme } from "uikit";
import { useTranslation } from "react-i18next";

import Map, { type PolygonList } from "../../../../DispatcherMap";
import { useTypedSelector } from "../../../../../redux/store";

const SectorsBase: React.FC<SectorsBase.Props> = ({
	taxiServiceIds,
	taxiServiceId,
}): JSX.Element => {
	const { t } = useTranslation();

	const language = useTypedSelector((state) => state.session.language);

	const items = useTypedSelector(
		(state) => state.globalState.carSectors.data.subscription.basic,
	);

	const text = useMemo(
		() => t(`mainPage.archives.orders.modal.map.polygons.sector`),
		[t],
	);

	const value = useMemo<PolygonList | undefined>(() => {
		if (Array.isArray(taxiServiceIds)) {
			return items
				?.filter((item) => taxiServiceIds.includes(item?.taxiServiceId))
				.map((sector) => ({
					id: sector.id,
					name:
						`${text} ${sector.name?.[language]}` ||
						Object.values(sector.name)?.[0],
					color: theme.colors.warning,
					vertices: sector.vertices.map((v) => [v.lat, v.lng]),
					editable: false,
				}));
		}

		if (taxiServiceId) {
			return items
				?.filter((item) => item?.taxiServiceId === taxiServiceId)
				.map((sector) => ({
					id: sector.id,
					name:
						`${text} ${sector.name?.[language]}` ||
						Object.values(sector.name)?.[0],
					color: theme.colors.warning,
					vertices: sector.vertices.map((v) => [v.lat, v.lng]),
					editable: false,
				}));
		}

		return items.map((sector) => ({
			id: sector.id,
			name:
				`${text} ${sector.name?.[language]}` ||
				Object.values(sector.name)?.[0],
			color: theme.colors.warning,
			vertices: sector.vertices.map((v) => [v.lat, v.lng]),
			editable: false,
		}));
	}, [taxiServiceIds, taxiServiceId, items, text, language]);

	return <Map.PolygonEditor value={value} editing={false} />;
};

declare namespace SectorsBase {
	interface Props {
		taxiServiceId?: number;
		taxiServiceIds?: number[];
	}
}
const Sectors = memo(SectorsBase);

export default Sectors;
